import { Link, useLocation, useSearchParams } from 'react-router-dom';
import SidePanel from '../../components/side-panel/SidePanel';
import { useFirmContext } from '../../providers/FirmProvider';
import { useWorksheet } from '../../queries/use-worksheet';
import { WorksheetTypeEnum } from '../../types/worksheet';
import CalculationsPreview from './calculations-preview/CalculationsPreview';
import ChecklistPreview from './checklist-preview/ChecklistPreview';
import CommentsPreview from './comments-preview/CommentsPreview';
import EntriesPreview from './entries-preview/EntriesPreview';
import FilesPreview from './files-preview/FilesPreview';
import HistoryPreview from './history-preview/HistoryPreview';
import JournalsPreview from './journals-preview/JournalsPreview';

import PreviewDetails from './PreviewDetails';
import QueriesPreview from './queries-preview/QueriesPreview';

function WorksheetPreview(): JSX.Element {
    const { shortId } = useFirmContext();
    const [params, setParams] = useSearchParams();
    const id = params.get('worksheetPreview') ?? undefined;

    const worksheetQuery = useWorksheet(id);

    function handleClose(): void {
        params.delete('worksheetPreview');
        setParams(params);
    }

    const worksheet = worksheetQuery.data?.worksheet;
    const collection = worksheet?.account ? 'trial-balance' : 'other-schedules';
    const worksheetUrl = `/${shortId}/workpapers/${worksheet?.workpaperId}/${collection}/${worksheet?.id}`;

    return (
        <SidePanel isOpen={Boolean(id)} onClose={handleClose} panelWidth={450}>
            <div className="w-full">
                {worksheet && (
                    <div>
                        <Link to={worksheetUrl} className="text-lg text-indigo-600 font-medium">
                            {worksheet.name}
                        </Link>
                        <div className="flex flex-col gap-4 mt-4">
                            <PreviewDetails worksheet={worksheet} />
                            <hr />
                            <EntriesPreview worksheet={worksheet} />
                            <hr />
                            <CalculationsPreview worksheet={worksheet} />
                            <hr />
                            <ChecklistPreview worksheet={worksheet} />
                            {worksheet.type === WorksheetTypeEnum.RECONCILIATION && (
                                <>
                                    <hr />
                                    <JournalsPreview worksheet={worksheet} />
                                </>
                            )}
                            <hr />
                            <FilesPreview worksheet={worksheet} />
                            <hr />
                            <CommentsPreview worksheet={worksheet} />
                            <hr />
                            <QueriesPreview worksheet={worksheet} />
                            <hr />
                            <HistoryPreview worksheet={worksheet} />
                        </div>
                    </div>
                )}
            </div>
        </SidePanel>
    );
}

export default WorksheetPreview;
